import axios from "axios";
import { ResponseType as AxiosResponseType } from "axios";
// utils
import { getAuthToken } from "./auth";
import { INVALID_TOKEN, USER_DEACTIVATED } from "config/codes";

function toQueryString(params: Record<string, any>): string {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    query.append(key, String(value));
  });

  return query.toString();
}
export const logOut = (code: any, navigate?: (path: string) => void) => {
  if (code === INVALID_TOKEN || code === USER_DEACTIVATED) {
    localStorage.clear();
    if (navigate) {
      navigate("/");
      window.location.reload();
    }
  }
};

export const getRequest = async (
  endpoint: string,
  params: Record<string, any>,
  navigate: (path: string) => void,
  headers?: Record<string, string>,
  responseType?: AxiosResponseType
) => {
  const token = getAuthToken();

  const newHeaders = {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
  const apiURL = process.env.REACT_APP_API_URL || "";

  let response;
  const fullUrl = `${apiURL}/${
    endpoint.endsWith("/") ? endpoint : endpoint + "/"
  }`;

  try {
    response = await axios.get(`${fullUrl}`, {
      params: params || {},
      headers: newHeaders,
      responseType: responseType || undefined,
    });
    if (!response.data.isOk) {
      logOut(response.data.code, navigate);
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const postRequest = async (
  endpoint: string,
  params: Record<string, any>,
  navigate: (path: string) => void,
  headers?: Record<string, string>
) => {
  const token = getAuthToken();

  const newHeaders = {
    ...headers,
    Authorization: `Bearer ${token}`,
  };

  const apiURL = process.env.REACT_APP_API_URL || "";

  let response;
  try {
    response = await axios.post(`${apiURL}/${endpoint}`, params, {
      headers: newHeaders,
    });
    if (!response.data.isOk) {
      logOut(response.data.code, navigate);
    }
  } catch (error) {}

  return response;
};

export const putRequest = async (
  endpoint: string,
  params: Record<string, any>,
  navigate: (path: string) => void,
  headers?: Record<string, string>
) => {
  const token = getAuthToken();

  const newHeaders = {
    ...headers,
    Authorization: `Bearer ${token}`,
  };

  const apiURL = process.env.REACT_APP_API_URL || "";

  let response;
  try {
    response = await axios.put(`${apiURL}/${endpoint}`, params, {
      headers: newHeaders || {},
    });
    if (!response.data.isOk) {
      logOut(response.data.code, navigate);
    }
  } catch (error) {}

  return response;
};
export const deleteRequest = async (
  endpoint: string,
  params: Record<string, any> = {},
  navigate: (path: string) => void,
  headers?: Record<string, string>
) => {
  const token = getAuthToken();

  const newHeaders = {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
  const apiURL = process.env.REACT_APP_API_URL || "";

  let response;
  try {
    response = await axios.delete(`${apiURL}/${endpoint}`, {
      data: params || {},
      headers: newHeaders || {},
    });
    if (!response.data.isOk) {
      logOut(response.data.code, navigate);
    }
  } catch (error) {
    console.error(error);
  }

  return response;
};

export const postRequestFormData = async (
  endpoint: string,
  formData: FormData,
  headers: Record<string, string> = {},
  navigate: (path: string) => void,
  responseType: AxiosResponseType = "blob"
) => {
  const token = getAuthToken();

  const newHeaders = {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
  const apiURL = process.env.REACT_APP_API_URL || "";

  let response;
  try {
    response = await axios.post(`${apiURL}/${endpoint}`, formData, {
      headers: {
        ...newHeaders,
      },
      responseType: responseType,
    });

    if (response.data && response.data.isOk === false) {
      logOut(response.data.code, navigate);
    }
  } catch (error) {
    console.error("POST formData failed:", error);
  }

  return response;
};
